import { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { UserRole, type CollectionYard } from '@/types'
import RichText from '@/components/rich-text'
import CollectionYardActions from '@/components/collection-yard/actions'
import CollectionYardForm from '@/components/forms/collection-yard'
import PermissionsGate from '@/components/permissions-gate'
import MunicipalityPermissionGate from '../municipality-permission-gate'

function CollectionYardDetails({
    collectionYard,
}: {
    collectionYard: CollectionYard,
}) {

    const [edit, setEdit] = useState<boolean>(false)

    return (
        <Box position="relative" px={2.5}>
            <Typography variant="h4" component="h3" mb={1}>
                {collectionYard.name}
            </Typography>
            <Box pt={2}>
                {edit ?
                    <CollectionYardForm
                        collectionYard={collectionYard}
                        closeCallback={() => setEdit(false)}
                    />
                    :
                    <>
                        <RichText content={collectionYard.description} />
                        <PermissionsGate
                            userRoles={[
                                UserRole.admin,
                                UserRole.municipalityOfficial,
                                UserRole.collectionCompany,
                            ]}
                        >
                            <MunicipalityPermissionGate hide>
                                <Box sx={{
                                    position: 'absolute',
                                    top: -4,
                                    right: 12,
                                    backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                    borderRadius: '1rem',
                                }}>
                                    <CollectionYardActions
                                        collectionYard={collectionYard}
                                        setEdit={setEdit}
                                    />
                                </Box>
                            </MunicipalityPermissionGate>
                        </PermissionsGate>
                    </>
                }
            </Box>
        </Box>
    )
}

export default CollectionYardDetails
